import { LoadPanel } from "devextreme-react";
import React from "react";

function LoaderPage({ loading, children }) {

    const position = { of: '#loaderPanel' }; //
    return (
        <React.Fragment >

            {
                <div className={'content-block'} id="loaderPanel">
                    <div className={'dx-card responsive-paddings'}>
                        {children}
                    </div>
                </div>
            }

            <LoadPanel
                visible={loading}
                position={position}
            //shadingColor="rgba(0,0,0,0.4)"
            />

        </React.Fragment>
    )

}

export default LoaderPage